import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Box from "@mui/material/Box";
import ResponsiveRouters from "./Responsive/ResponsiveRouters";
import NavbarMain from "./Components/Navbar/NavBarMain";
import FooterMain from "./Components/Footer/FooterMain";
import ScrollToTopButton from "./Components/Main/HomePage/Authentication/ScrollToTopButton";
import SecurityLayer from "./Tests/SecurityLayer";
import Aibot from "./Components/Main/HomePage/Authentication/Aibot";
import UsageTracker from "./Components/UsageTracker/UsageTracker";

/**
 * ResponsiveApp is a parallel application shell that mirrors App.tsx but swaps
 * the legacy AppRouters for ResponsiveRouters, which renders the appropriate
 * Mobile / Tablet / Desktop variant of each page based on the current viewport.
 *
 * App.tsx is intentionally left untouched — it remains the single-variant
 * (desktop) entry that the old build was using. Set the import in index.tsx
 * back to "./App" if you ever need the legacy shell.
 */
const ResponsiveApp: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <SecurityLayer />

      <Router>
        <UsageTracker />
        <NavbarMain />
        <Box
          sx={{
            flex: 1,
          }}
        >
          <ResponsiveRouters />
        </Box>
        <FooterMain />
        <Aibot />
        <ScrollToTopButton />
      </Router>
    </Box>
  );
};

export default ResponsiveApp;
